import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { PagesComponent } from './pages.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from '../shared/services/auth.guard';
import { ExComponent } from './exercises/ex.component';
import { FavsComponent } from './favs/favs.component';
import { NotificationComponent } from './notification/notification.component';
import { StatsComponent } from './stats/stats.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { SettingsComponent } from './settings/settings.component';
import { GenericPageComponent } from './generic-page/generic-page.component';
import { SupportComponent } from './support/support.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { ContinueComponent } from './continue/continue.component';
import { DeleteComponent } from './delete/delete.component';
import { TeamSelectComponent } from './team-select/team-select.component';
import { ChallengeTutorialComponent } from './challenge-tutorial/challenge-tutorial.component';
import { RedirectComponent } from './redirect/redirect.component';

const PAGES_ROUTES: Routes = [
  {
    path: '',
    component: PagesComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
        canActivate: [AuthGuard],
      },
      {
        path: 'dashboard',
        loadChildren: './dashboard/dashboard.module#DashboardModule',
        data: { roles: ['admin', 'user'] },
        canActivate: [AuthGuard],
      },
      { path: 'challenge/:challengeID/team', component: TeamSelectComponent, canActivate: [AuthGuard] },
      { path: 'challengeTutorial', component: ChallengeTutorialComponent, canActivate: [AuthGuard] },
      { path: 'exercises', component: ExComponent, canActivate: [AuthGuard] },
      { path: 'favs', component: FavsComponent, canActivate: [AuthGuard] },
      { path: 'stats', component: StatsComponent, canActivate: [AuthGuard] },
      { path: 'notification', component: NotificationComponent, canActivate: [AuthGuard] },
      { path: 'settings', component: SettingsComponent, canActivate: [AuthGuard] },
      { path: 'support', component: SupportComponent, canActivate: [AuthGuard] },

      { path: 'faq', component: GenericPageComponent, data: { page: 'faq', title: 'NAVIGATION.navFAQ' } },
      { path: 'imprint', component: GenericPageComponent, data: { page: 'imprint', title: 'NAVIGATION.navImprint' } },
      { path: 'tos', component: GenericPageComponent, data: { page: 'tos', title: 'NAVIGATION.navToS' } },
      { path: 'privacy', component: GenericPageComponent, data: { page: 'privacy', title: 'NAVIGATION.navPrivacy' } },
      {
        path: 'copyright',
        component: GenericPageComponent,
        data: { page: 'copyright', title: 'NAVIGATION.navCopyright' },
      },
    ],
  },

  { path: 'login', component: LoginComponent },
  { path: 'login/reset', component: LoginComponent },
  { path: 'login/reset/:lan/:token', component: PasswordResetComponent },
  { path: 'signup/:data/:token', component: SignUpComponent },
  { path: 'signup/:data/:token/:botoken', component: SignUpComponent },
  { path: 'continue/:language/:token', component: ContinueComponent },
  { path: 'delete/:language/:token', component: DeleteComponent },
  { path: 'admin', component: RedirectComponent, data: { target: 'admin' }, children: [{ path: '**', redirectTo: '/admin', pathMatch: 'full' }]},
];

@NgModule({
  imports: [RouterModule.forChild(PAGES_ROUTES)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/pages.routing.ts